export const I18n = {
    'en': {

    },
    'ru': {
        name: 'Приложение',
        keys: 'Ключи',
        redirects: 'Переходы',
        companies: 'Кампании',
        promoPage_title: 'Приложения',
        addApp: 'Добавить приложение',
        promo: 'Добавить кампанию',
        start: 'Запуск',
        edit: 'Редактировать',
        stop: 'Остановить',
        delete: 'Удалить',
        offerList_icon: 'Иконка',
        offerList_name: 'Имя кампании',
        offerList_reward: 'Вознаграждение',
        offerList_redirectCount: `Кол-во 
                              переходов`,
        offerList_startDate: 'Дата начала',
        offerList_endDate: 'Дата окончания',
        offerList_limit: 'Лимит',
        offerList_model: 'Модель',
        offerList_offer: 'Оффер',
        offerList_status: 'Статус',
        offerList_title: 'Кампании',
        offerList_active: 'Активный',
        offerList_draft: 'Драфт',
        offerList_canceled: 'Отменен',
        offerList_finished: 'Закончен',
        offerList_stopped: 'Остановлен',
        promotion: 'Продвижение',
        accept: 'Принять',
        declined: 'Отменить',
        cancel: 'Остановить'
    },
    'sk': {

    }
};



// WEBPACK FOOTER //
// ./src/I18n/components/promoPage/index.js